const accordionWithAccessibility = options => {
    Array.from(document.querySelectorAll(options.wrapper)).forEach(accordion => {
        const allowMultiple = accordion.hasAttribute('data-allow-multiple');
        const allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');
        const triggersSelString = options.trigger ? options.trigger : '.accordion-trigger';
        const triggersSelStringText = triggersSelString.replace(/\.|#/, '');
        const triggers = Array.from(accordion.querySelectorAll(triggersSelString));
        const expandAccordion = target => {
            target.setAttribute('aria-expanded', 'true');
            if (options.openText && options.closeText) {
                target.querySelector('.accordion-title').innerHTML = options.openText;
            }
            document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');
            if (!allowToggle) {
                target.setAttribute('aria-disabled', 'true');
            }
        }

        const collapseAccordion = target => {
            target.setAttribute('aria-expanded', 'false');
            document.getElementById(target.getAttribute('aria-controls')).setAttribute('hidden', '');
        }

        accordion.addEventListener('click', (e) => {
            const target = e.target;
            if (target.classList.contains(triggersSelStringText)) {
                const isExpanded = target.getAttribute('aria-expanded') == 'true';
                if (!isExpanded) {
                    expandAccordion(target);
                } else if (allowToggle && isExpanded) {
                    collapseAccordion(target);
                }

                e.preventDefault();
            }
        });

        accordion.addEventListener('keydown', (e) => {
            const target = e.target;
            const key = e.which.toString();
            const ctrlModifier = (e.ctrlKey && key.match(/33|34/));
            if (target.classList.contains(triggersSelStringText)) {
                if (key.match(/38|40/) || ctrlModifier) {
                    const index = triggers.indexOf(target);
                    const direction = (key.match(/34|40/)) ? 1 : -1;
                    const length = triggers.length;
                    const newIndex = (index + length + direction) % length;
                    triggers[newIndex].focus();
                    e.preventDefault();
                } else if (key.match(/35|36/)) {
                    switch (key) {
                        case '36':
                            triggers[0].focus();
                            break;
                        case '35':
                            triggers[triggers.length - 1].focus();
                            break;
                    }
                    e.preventDefault();
                }
            }
            if (key.match(/27/)) {
                if (target.classList.contains(triggersSelStringText)) {
                    expandAccordion(target);
                } else {
                    const buttonSel = target.closest(options.wrapper).querySelector(triggersSelString);
                    collapseAccordion(buttonSel);
                }
            }
        });

        accordion.querySelectorAll(triggersSelString).forEach(trigger => {
            trigger.addEventListener('focus', () => {
                accordion.classList.add('focus');
            });
            trigger.addEventListener('blur', () => {
                accordion.classList.remove('focus');
            });
        });
        if (!allowToggle) {
            const expanded = accordion.querySelector('[aria-expanded="true"]');
            if (expanded) {
                expanded.setAttribute('aria-disabled', 'true');
            }
        }
    });
    function fnBrowserDetect() {
        let userAgent = navigator.userAgent;
        if (userAgent.match(/firefox|fxios/i)) {
            const labels = document.querySelectorAll(".accordion-label");
            labels.forEach((label) => {
                label.style.padding = "0.6rem 0.4rem 0.5rem 0.4rem";
            });
        }
    }
    fnBrowserDetect();
}
accordionWithAccessibility({
    wrapper: ".accordion-wrapper"
});


